import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Motorcycle, Wallet, SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

const NavItem = ({ to, icon: Icon, label, colour }) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) =>
      `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold border-2 transition ${
        isActive ? "text-white border-[var(--text)]" : "text-[var(--text)] border-transparent hover:border-[var(--text)]"
      }`
    }
    style={({ isActive }) => (isActive ? { background: colour, boxShadow: "3px 3px 0 0 var(--text)" } : {})}
  >
    <Icon size={18} weight="fill" />
    <span>{label}</span>
  </NavLink>
);

export default function DriverLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--cream)] text-[var(--text)]">
      <header className="sticky top-0 z-40 bg-[var(--cream)] border-b-[3px] border-[var(--text)]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-3">
          <div className="flex items-center gap-2 mr-2">
            <div
              className="w-9 h-9 rounded-full bg-[var(--blue)] border-2 border-[var(--text)] flex items-center justify-center"
              style={{ boxShadow: "3px 3px 0 0 var(--text)" }}
            >
              <Motorcycle size={18} weight="fill" className="text-white" />
            </div>
            <span className="font-display text-lg">Tjoef · Driver</span>
          </div>
          <nav className="flex items-center gap-2 flex-1">
            <NavItem to="/driver" icon={Motorcycle} label="Dispatch" colour="var(--blue)" />
            <NavItem to="/driver/earnings" icon={Wallet} label="Earnings" colour="var(--green)" />
          </nav>
          <span className="text-xs font-bold text-[var(--text-2)] hidden sm:inline">{user?.name}</span>
          <button
            onClick={async () => {
              await logout();
              navigate("/");
            }}
            className="w-9 h-9 rounded-full border-2 border-[var(--text)] bg-white hover:bg-[var(--yellow)] flex items-center justify-center"
            style={{ boxShadow: "3px 3px 0 0 var(--text)" }}
            title="Sign out"
          >
            <SignOut size={16} weight="bold" />
          </button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 pb-24">{children}</main>
      <Toaster theme="light" position="top-center" richColors />
    </div>
  );
}
